function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }
var id = 0;
function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }
var _data = /*#__PURE__*/_classPrivateFieldLooseKey("data");
var _meta = /*#__PURE__*/_classPrivateFieldLooseKey("meta");
var _metaUpdater = /*#__PURE__*/_classPrivateFieldLooseKey("metaUpdater");
var _setMeta = /*#__PURE__*/_classPrivateFieldLooseKey("setMeta");
var _parent = /*#__PURE__*/_classPrivateFieldLooseKey("parent");
var _children = /*#__PURE__*/_classPrivateFieldLooseKey("children");
var _listeners = /*#__PURE__*/_classPrivateFieldLooseKey("listeners");
var _sendSignal = /*#__PURE__*/_classPrivateFieldLooseKey("sendSignal");
/* eslint-disable no-param-reassign */
/* eslint-disable max-classes-per-file */
var Node = /*#__PURE__*/function () {
  Node.factory = function factory(nodeObject) {
    var node = new Node(nodeObject.data, nodeObject.meta);
    if (nodeObject.children) {
      nodeObject.children.forEach(function (child) {
        node.addChild(Node.factory(child));
      });
    }
    return node;
  };
  function Node(data) {
    var _this = this;
    Object.defineProperty(this, _data, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _meta, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _metaUpdater, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _setMeta, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _parent, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _children, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _listeners, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _sendSignal, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _data)[_data] = data;
    _classPrivateFieldLooseBase(this, _meta)[_meta] = {};
    _classPrivateFieldLooseBase(this, _metaUpdater)[_metaUpdater] = {};
    _classPrivateFieldLooseBase(this, _parent)[_parent] = null;
    _classPrivateFieldLooseBase(this, _children)[_children] = [];
    _classPrivateFieldLooseBase(this, _listeners)[_listeners] = [];
    _classPrivateFieldLooseBase(this, _setMeta)[_setMeta] = function (name, value) {
      var _Object$assign;
      if (value instanceof Function) {
        value = value(_classPrivateFieldLooseBase(_this, _meta)[_meta][name]);
      }
      var oldMeta = _classPrivateFieldLooseBase(_this, _meta)[_meta];
      _classPrivateFieldLooseBase(_this, _meta)[_meta] = Object.assign({}, _classPrivateFieldLooseBase(_this, _meta)[_meta], (_Object$assign = {}, _Object$assign[name] = value, _Object$assign));
      _this.sendSignal('metaUpdated', {
        oldMeta: oldMeta,
        newMeta: _classPrivateFieldLooseBase(_this, _meta)[_meta]
      }, _this);
    };
    _classPrivateFieldLooseBase(this, _sendSignal)[_sendSignal] = function (signal, d, origin) {
      _classPrivateFieldLooseBase(_this, _listeners)[_listeners].forEach(function (listener) {
        listener(signal, d, origin);
      });
    };
  }
  var _proto = Node.prototype;
  _proto.setMeta = function setMeta(name, value) {
    _classPrivateFieldLooseBase(this, _setMeta)[_setMeta](name, value);
  };
  _proto.useMeta = function useMeta(name, initialValue) {
    if (_classPrivateFieldLooseBase(this, _meta)[_meta][name] === undefined) {
      _classPrivateFieldLooseBase(this, _meta)[_meta][name] = initialValue;
      _classPrivateFieldLooseBase(this, _metaUpdater)[_metaUpdater][name] = _classPrivateFieldLooseBase(this, _setMeta)[_setMeta].bind(this, name);
    }
    return [_classPrivateFieldLooseBase(this, _meta)[_meta][name], _classPrivateFieldLooseBase(this, _metaUpdater)[_metaUpdater][name]];
  };
  _proto.isRoot = function isRoot() {
    return !_classPrivateFieldLooseBase(this, _parent)[_parent];
  };
  _proto.hasChildren = function hasChildren() {
    return !!_classPrivateFieldLooseBase(this, _children)[_children].length;
  };
  _proto.addChild = function addChild(node, getIndex) {
    if (getIndex === void 0) {
      getIndex = function getIndex(brothers) {
        return brothers.length;
      };
    }
    var index = getIndex(_classPrivateFieldLooseBase(this, _children)[_children].slice());
    if (index < 0 || index > _classPrivateFieldLooseBase(this, _children)[_children].length) {
      return false;
    }
    if (!node.isRoot()) {
      _classPrivateFieldLooseBase(node, _parent)[_parent].removeChild(node);
    }
    _classPrivateFieldLooseBase(this, _children)[_children].splice(index, 0, node);
    _classPrivateFieldLooseBase(node, _parent)[_parent] = this;
    node.sendSignal('parentAdded', {
      parent: this
    });
    this.sendSignal('childAdded', {
      child: node
    });
    this.sendSignalToParent('informChildAdded', {
      child: node
    });
    return true;
  };
  _proto.removeChild = function removeChild(node) {
    var index = _classPrivateFieldLooseBase(this, _children)[_children].indexOf(node);
    if (index !== -1) {
      _classPrivateFieldLooseBase(_classPrivateFieldLooseBase(this, _children)[_children][index], _parent)[_parent] = null;
      _classPrivateFieldLooseBase(this, _children)[_children].splice(index, 1);
      node.sendSignal('parentRemoved', {
        parent: this
      });
      this.sendSignal('childRemoved', {
        child: node
      });
      this.sendSignalToParent('informChildRemoved', {
        child: node
      });
      return true;
    }
    return false;
  };
  _proto.propagateToParent = function propagateToParent(handler, last) {
    last = handler(this, last);
    if (!this.isRoot()) {
      last = _classPrivateFieldLooseBase(this, _parent)[_parent].propagateToParent(handler, last);
    }
    return last;
  };
  _proto.propagateToChildren = function propagateToChildren(handler, last) {
    last = handler(this, last);
    // eslint-disable-next-line no-restricted-syntax
    for (var _iterator = _createForOfIteratorHelperLoose(_classPrivateFieldLooseBase(this, _children)[_children]), _step; !(_step = _iterator()).done;) {
      var child = _step.value;
      last = child.propagateToChildren(handler, last);
    }
    return last;
  };
  _proto.find = function find(handler) {
    if (handler(this)) {
      return this;
    }
    return _classPrivateFieldLooseBase(this, _children)[_children].reduce(function (founded, node) {
      return founded || node.find(handler);
    }, null);
  };
  _proto.addSignalListener = function addSignalListener(listener) {
    _classPrivateFieldLooseBase(this, _listeners)[_listeners].push(listener);
  };
  _proto.removeSignalListener = function removeSignalListener(listener) {
    var index = _classPrivateFieldLooseBase(this, _listeners)[_listeners].indexOf(listener);
    if (index !== -1) {
      _classPrivateFieldLooseBase(this, _listeners)[_listeners].splice(index, 1);
    }
  };
  _proto.sendSignal = function sendSignal(signal, data) {
    _classPrivateFieldLooseBase(this, _sendSignal)[_sendSignal](signal, data, this);
  };
  _proto.sendSignalToParent = function sendSignalToParent(signal, data) {
    var _this2 = this;
    (function (origin) {
      _this2.propagateToParent(function (node) {
        _classPrivateFieldLooseBase(node, _sendSignal)[_sendSignal](signal, data, origin);
      });
    })(this);
  };
  _proto.sendSignalToChildren = function sendSignalToChildren(signal, data) {
    var _this3 = this;
    (function (origin) {
      _this3.propagateToChildren(function (node) {
        _classPrivateFieldLooseBase(node, _sendSignal)[_sendSignal](signal, data, origin);
      });
    })(this);
  };
  _createClass(Node, [{
    key: "data",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _data)[_data];
    },
    set: function set(value) {
      var copy = Object.assign({}, _classPrivateFieldLooseBase(this, _data)[_data]);
      _classPrivateFieldLooseBase(this, _data)[_data] = value;
      this.sendSignal('dataUpdated', {
        oldData: copy,
        newData: _classPrivateFieldLooseBase(this, _data)[_data]
      }, this);
    }
  }, {
    key: "meta",
    get: function get() {
      return Object.assign({}, _classPrivateFieldLooseBase(this, _meta)[_meta]);
    }
  }, {
    key: "root",
    get: function get() {
      if (this.isRoot()) {
        return this;
      }
      return _classPrivateFieldLooseBase(this, _parent)[_parent].root;
    }
  }, {
    key: "parent",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _parent)[_parent];
    }
  }, {
    key: "children",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _children)[_children].slice();
    }
  }, {
    key: "deep",
    get: function get() {
      if (this.isRoot()) {
        return 0;
      }
      return this.parent.deep + 1;
    }
  }]);
  return Node;
}();
var _node = /*#__PURE__*/_classPrivateFieldLooseKey("node");
var Builder = /*#__PURE__*/function () {
  Builder.create = function create(data) {
    return new Builder(data);
  };
  function Builder(data) {
    Object.defineProperty(this, _node, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _node)[_node] = new Node(data);
  }
  var _proto2 = Builder.prototype;
  _proto2.addChild = function addChild(node) {
    _classPrivateFieldLooseBase(this, _node)[_node].addChild(node);
    return this;
  };
  _proto2.addSignalListener = function addSignalListener(listener) {
    _classPrivateFieldLooseBase(this, _node)[_node].addSignalListener(listener);
    return this;
  };
  _proto2.build = function build() {
    return _classPrivateFieldLooseBase(this, _node)[_node];
  };
  return Builder;
}();
Node.Builder = Builder;
export default Node;